<template>
  <div class="row primary-filter">
    <div class="col-md-auto filter-grid">
      <ul class="inlinelist">
        <li class="app-side-menu">
          <span @click="isOpen = true" class="pointer">
            <svgicon name="menu" width="20" height="20" :original="true" class="menu" />
          </span>
          <div class="sidemenu-slideout" :class="{ isOpen: isOpen }">
            <Sidebar v-on:close="isOpen = false" />
          </div>
        </li>
        <!-- <li class="color-changes category">
          <FilterDropdown
            v-if="menuOptions.length"
            :options="menuOptions"
            :selected="selectedCategory"
            v-on:updateOption="onChangeOption" />
        </li> -->
        <li class="category">
          <div class="dropdown">
            <div class="dropdown-selected">
              Track
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="col filter-grid">
      <div class="row">
        <div class="col">
          <div class="app-search-label">
          <div>

            <div class="searchterm tagblock" v-on:click="openSearchPopup=true" v-if="!openSearchPopup" v-bind:class="{ 'pointer' : noParams}">
              <svgicon name="search" width="15" height="15"
              :original="true" />
              <span type="text" class="tagblock_list">
                <span v-for= "(value, name, index) in params" :key="index">
                  <Tag closable @close="removeParamTag(name)" v-if="value">{{value}}</Tag>
                </span>
                <span v-if="noParams">{{searchText}}</span>
              </span>
            </div>

            <div class="searchterm" v-if="openSearchPopup">
              <div class="bg-overlay"></div>
              <div class="searchcontent" v-click-outside="closeSearch">
                <div class="searchpopup">
                  <div class="searchpopup-grid">
                    <ul class="searchpopup-grid-list">
                      <li>
                        <div class="searchpopup-grid-list-header">
                          Source
                          <Checkbox :value="source?true:false" @change="unCheck('source')"
                            :disabled="source?false:true"></Checkbox>
                        </div>
                        <div class="dropdown-section">
                          <input type="text" placeholder="Enter location here" v-model="source">
                        </div>
                      </li>
                      <li>
                        <div class="searchpopup-grid-list-header">
                          Destination
                          <Checkbox :value="destination?true:false" @change="unCheck('destination')"
                            :disabled="destination? false: true"></Checkbox>
                        </div>
                        <div class="dropdown-section">
                          <input type="text" placeholder="Enter location here" v-model="destination">
                          </div>
                      </li>
                      <li>
                        <div class="searchpopup-grid-list-header">
                          Truck Number
                          <Checkbox :value="vehicleNumber?true:false" @change="unCheck('vehicleNumber')"
                            :disabled="vehicleNumber?false:true"></Checkbox>
                        </div>
                        <div class="dropdown-section">
                          <input type="text" placeholder="Enter Number here" v-model="vehicleNumber">
                        </div>
                      </li>
                      <li>
                        <div class="searchpopup-grid-list-header">
                          Reference ID
                          <Checkbox :value="referenceId?true:false" @change="unCheck('referenceId')"
                            :disabled="referenceId?false:true"></Checkbox>
                        </div>
                        <div class="dropdown-section">
                          <input type="text" placeholder="Enter Number here" v-model="referenceId">
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="btn-group">
                    <button class="btn section_obtn" @click="resetAll">Clear</button>
                    <button class="btn section_pbtn" @click="search(); closeSearch();">Search</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          </div>
        </div>
      </div>
    </div>

    <div class="col-md-auto filter-grid filter-button" v-if="$hasPermission('update_tracking')">
      <ul class="filter-btn-group inlinelist">
      <li>
        <button class="btn header_pbtn" @click="addTrip" :disabled="disableAddButton" :class="{'disablebtn' : disableAddButton}">Add</button>
      </li>
      </ul>
    </div>
  </div>
</template>

<script>
import debounce from 'debounce';
import Sidebar from '@/modules/common/Sidebar';
import FilterDropdown from '@common/components/FilterDropdown';
export default {
  props: ['canCreateInvoice','isPayment','searchText','menuOptions','selectedCategory','queryParams', 'buttonsList','selectedIds','filterParams','disableAddButton'],
  components: {
    Sidebar,
    FilterDropdown,
  },
  data() {
    return {
      query: null,
      isOpen: false,
      focusSearch: true,
      openSearchPopup:false,
      params: {},
      source:null,
      destination:null,
      vehicleNumber:null,
      referenceId:null,
    };
  },
  computed: {
    noParams() {
      return (Object.values(this.params).findIndex(val => val != null || (val === 'null' && typeof val === 'object' && ( val != null || val.name != null ))) === -1);
    },
  },
  methods: {
    onClick(){
      this.focusSearch = false;
    },
    closeSearch() {
      this.openSearchPopup = false;
    },
    search() {
      this.params = {
        source: this.source,
        destination: this.destination,
        vehicleNumber: this.vehicleNumber,
        referenceId: this.referenceId,
      };
      this.$emit('search',this.params);
    },
    resetAll() {
      this.source = this.destination = null;
      this.vehicleNumber = null;
      this.referenceId = null;
      this.search();
    },
    unCheck(section) {
      this[section] = null;
    },
    removeParamTag(section) {
      this.unCheck(section);
      this.search();
    },
    addTrip() {
      this.$emit('showTripForm');
    },
  },
};
</script>


<style lang="scss">
@import "~@common/styles-transporter/settings";
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';
.primary-filter {
    border: 1px solid #E9F1F5;
    background-color: #fff;
    height: 50px;
    margin-left: -20px !important;
    margin-right: -20px !important;
    font-family:$fontSemibold;
    .dropdown-menu {
        top: 32px !important;
    }
    .filter-grid {
        padding-left: 0;
        padding-right: 0;
        // border-left: 1px solid #CBD4D8;
        ul {
            @extend %list-unstyled;
            li {
                display: inline-block;
            }
            .app-side-menu {
                // background-color: #F2F1F1;
                padding: 14px 0;
                width: 69px;
                text-align: center;
                position: relative;
                top: -2px;
                //background: #F2F1F1;
                cursor: pointer;
            }
            .category {
                // width: 151px;
                // padding: 4px 10px;
                color: #007FEA;
                // padding-left: 10px;
                border-right: 1px solid #E9F1F5;
                border-left: 1px solid #E9F1F5;
                font-size: 1.4rem;
                text-transform: uppercase;
                margin-left: -3px;
                position: relative;
                top: -1px;
                height: 49px;
            }
            .search {
                padding: 0 20px;
                width: 50%;
                svg {
                    position: relative;
                    top: 0px;
                }
                input {
                    outline: none;
                    border: 1px solid transparent;
                    padding: 0 5px;
                    width: 90%;
                    font-size: 1.4rem;
                }
            }
        }
        &.filter-button {
            ul {
                @extend %list-unstyled;
                float: right;
                padding: 9.5px 10px;
                li {
                    margin: 0 0 0 18px;
                    &:last-child {
                        margin: 0 0 0 10px;
                    }
                    .btn-primary {
                        @extend %header-primary-btn;
                        @extend %bold;
                        color: #fff;
                        text-transform: uppercase;
                    }
                    .btn-secondary {
                        @extend %header-secondary-btn;
                        @extend %bold;
                        color: #008AFF;
                        text-transform: uppercase;
                    }
                }
            }
        }
    }
}
</style>